module.exports = __webpack_public_path__ + "static/media/24.185731d1.svg";